import EDocumentImportWizard from "@components/content/EDocumentImportWizard";
import debitnoteImportDefinition from "@utils/edocumentImport/definitions/debitnoteImport";

/**
 * Carga masiva de notas de debito electronicas ya emitidas.
 *
 * Toda la logica vive en el asistente agnostico y en la definicion del documento: esta pagina
 * solo elige cual.
 */
const DebitnoteImport = () => <EDocumentImportWizard definition={debitnoteImportDefinition} />;

export default DebitnoteImport;
